import API_URLS from '@Constants/apiUrls.constants';
import { CommonConstants } from '@Constants/index';
import { GetLists } from '@Models/common.models';
import {
  DeleteEmails,
  GlobalEmailAdd,
  GlobalEmailEdit,
  GlobalEmailResponse,
  GlobalEmailsListResponse,
} from '@Models/emails.models';
import { baseApi } from '@Services/baseApi.service';
import query from '@Utils/common/query.utils';

export const globalEmailTemplatesApi = baseApi
  .enhanceEndpoints({
    addTagTypes: ['GlobalEmails', 'GlobalEmail', 'Emails', 'Email'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getGlobalEmails: builder.query<GlobalEmailsListResponse, GetLists>({
        query: ({ data: { direction, ...resData }, isArchive = false }) =>
          `${API_URLS.GLOBAL_EMAILS}${isArchive ? '?archive&' : '?'}${
            direction || CommonConstants.INITIAL_SORT_DIRECTION
          }&${query.stringify({ ...resData })}`,
        providesTags: ['GlobalEmails'],
      }),
      getGlobalEmail: builder.query<GlobalEmailResponse, string>({
        query: (id) => `${API_URLS.GLOBAL_EMAILS}/${id}`,
        providesTags: ['GlobalEmail'],
      }),
      addGlobalEmail: builder.mutation<GlobalEmailResponse, GlobalEmailAdd>({
        query: (body) => ({
          url: `${API_URLS.GLOBAL_EMAILS}`,
          method: 'POST',
          body,
        }),
        invalidatesTags: ['GlobalEmails', 'GlobalEmail', 'Emails', 'Email'],
      }),
      editGlobalEmail: builder.mutation<GlobalEmailResponse, GlobalEmailEdit>({
        query: (body) => ({
          url: `${API_URLS.GLOBAL_EMAILS}/${body.id}`,
          method: 'PUT',
          body,
        }),
        invalidatesTags: ['GlobalEmails', 'GlobalEmail', 'Emails', 'Email'],
      }),
      deleteGlobalEmail: builder.mutation<void, string>({
        query: (id) => ({
          url: `${API_URLS.GLOBAL_EMAILS}/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['GlobalEmails', 'GlobalEmail', 'Emails', 'Email'],
      }),
      deleteGlobalEmails: builder.mutation<void, DeleteEmails>({
        query: (body) => ({
          url: `${API_URLS.GLOBAL_EMAILS}/delete`,
          method: 'PUT',
          body,
        }),
        invalidatesTags: ['GlobalEmails', 'GlobalEmail', 'Emails', 'Email'],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useGetGlobalEmailsQuery,
  useGetGlobalEmailQuery,
  useAddGlobalEmailMutation,
  useEditGlobalEmailMutation,
  useDeleteGlobalEmailMutation,
  useDeleteGlobalEmailsMutation,
} = globalEmailTemplatesApi;
